<template>
  <div>风险</div>
</template>

<script>
export default {

};
</script>

<style>

</style>
